/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS0Icon24Regular = forwardRef('MediaAudioVolumeS0Icon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.462 3.675C11.416 2.76 13 3.437 13 4.758v14.485c0 1.32-1.584 1.997-2.538 1.083L5.95 16H3.05A2.05 2.05 0 0 1 1 13.95v-3.9A2.05 2.05 0 0 1 3.05 8h2.899l4.513-4.325ZM11.5 4.758 6.987 9.083a1.5 1.5 0 0 1-1.038.417H3.05a.55.55 0 0 0-.55.55v3.9c0 .304.246.55.55.55h2.899a1.5 1.5 0 0 1 1.038.417l4.513 4.325V4.758Z" })));
});
